import { store } from 'dn-cookiebar';
export default store;
